export default "__VITE_ASSET__B1exs_jw__"